/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-30 10:34:47
 * @Description: 
 */
/**
  * 商城订单 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodorder = {
    // 列表
    list (params) {
        return axios.get(api + 'orders/list', { params: params })
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'orders/detail', { params: params })
    },
    //订单快照
    photo (params) {
        return axios.get(api + 'orders/photo', { params: params })
    },
    //关闭
    close (params) {
        return axios.post(api + 'orders/close', qs.stringify(params))
    },
    //发货
    ship (params) {
        return axios.post(api + 'orders/ship', qs.stringify(params))
    },
    //修改平台进价
    editPlatprice (params) {
        return axios.post(api + 'orders/editPlatprice', qs.stringify(params))
    },
    //导出未发货的订单
    unshipgoodorder (params) {
        return axios.post(api + 'orders/unshipgoodorder', qs.stringify(params))
    },
    //批量发货
    allshipgoodorder (params) {
        return axios.post(api + 'orders/allshipgoodorder', qs.stringify(params))
    },
}


// 导出接口
export default goodorder